<script>
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  export let items = [];
  export let limit = 5;

  let expanded = false;

  $: itemCount = items.length;
  $: limitedItems = expanded ? items : items.slice(0, limit);
</script>

<style type="text/scss">
  @import './styles/theme.scss';

  .words {
    @include fluid-font-size($fs-small);
    @include fluid-space(padding-top padding-bottom, $sp-xxsmall);
  }
  .word {
    cursor: pointer;
    color: $c-gray-0;
    display: inline-block;
    background-color: $c-gray-5;
    border-radius: 4px;
    margin: 0 3px 5px 0;
    padding: 3px 8px;
    transition: all 0.3s;
  }
  .word__count {
    color: $c-gray-2;
  }
  .button {
    color: $c-gray-2;
    border: 2px solid $c-gray-5;
    padding: 2px 10px;
    border-radius: 4px;
    cursor: pointer;
    white-space: pre;
  }
  .word:hover,
  .word.is-highlighted {
    color: #fff;
    border-color: #ee827e;
    background-color: #ee827e;
  }
  .word:hover .word__count,
  .word.is-highlighted .word__count {
    color: $c-white;
  }
  .button:hover {
    color: $c-white;
    border-color: $c-black;
    background-color: $c-black;
  }
</style>

<div class="words">
  {#each limitedItems as d (d.word)}
    <span
      class="word"
      class:is-highlighted={d.isHighlighted}
      on:mouseenter={() => {
        dispatch('mouseover', { id: d.word });
      }}
      on:mouseleave={() => {
        dispatch('mouseout', {});
      }}>
      {d.word}
      <span class="word__count">({d.value})</span>
    </span>
  {/each}
  {#if itemCount > limit}
    <span
      class="button"
      on:click={() => {
        expanded = !expanded;
      }}>
      {#if !expanded}+ Alle anzeigen ({itemCount}){:else}- Einklappen{/if}
    </span>
  {/if}
</div>
